export default __webpack_public_path__ + "static/media/ConfigureWebhookInNeto(1).4a6507c1.png";